var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMicrophone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.5V6c0-2.62 2.13-4.75 4.75-4.75S16.75 3.38 16.75 6v5.5c0 2.62-2.13 4.75-4.75 4.75s-4.75-2.13-4.75-4.75zM8.75 6v5.5c0 1.79 1.46 3.25 3.25 3.25s3.25-1.46 3.25-3.25V6c0-1.79-1.46-3.25-3.25-3.25S8.75 4.21 8.75 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 11.35v-1.7c0-.41.34-.75.75-.75s.75.34.75.75v1.7c0 3.8 3.1 6.9 6.9 6.9 3.8 0 6.9-3.1 6.9-6.9v-1.7c0-.41.34-.75.75-.75s.75.34.75.75v1.7c0 4.63-3.77 8.4-8.4 8.4-4.63 0-8.4-3.77-8.4-8.4zM13.13 7.14c-.73-.27-1.53-.27-2.26 0a.75.75 0 1 1-.51-1.41 4.89 4.89 0 0 1 3.29 0c.39.14.59.57.45.96a.776.776 0 0 1-.97.45z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 9.27c-.4-.11-.81-.11-1.21 0a.75.75 0 0 1-.92-.53c-.11-.39.13-.8.53-.91.65-.18 1.35-.18 2 0 .4.11.64.52.53.92-.09.33-.4.55-.73.55-.07 0-.13-.01-.2-.03zM11.25 22v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMicrophone2);
export default __webpack_public_path__ + "static/media/vuesax-outline-microphone-2.8f2391987e1ea45a9fa26669c223a4ce.svg";
export { ForwardRef as ReactComponent };